<template>
	<div class="relative" :class="has_error?'errorous':''">
		<input type="password" :id="id" class="form-control" v-model="input_value" :placeholder="placeholder">
  <label :for="id">{{placeholder}}</label>
	</div>
</template>
<script>
	export default{
		name: "SimplementPasswordInput",
		props: {
			value: {
				type: String
			},
			placeholder: {
				type: String
			},
			has_error: {
				type: Boolean,
				default: false
			}
		},
		data(){
			return {
				input_value: ''
			}
		},
		mounted(){
			this.input_value = this.value
		},
		watch: {
			// value(){
			// 	this.input_value = this.value
			// },
			input_value(){
				this.$emit('input', this.input_value)
			}
		},
		computed: {
			id(){
				return 'simplement-'+this._uid
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	input.form-control{
		border-radius: 8px ;
		background: rgba(238, 238, 238, 0.93) ;
		border: none ;
		height: 56px ;
	}
	input.form-control::placeholder{
		color: #8D8D8DEE !important;
		font-size: 14px;
	}
	input + label{
		font-size: 10px;
		margin-top: -.5em;
		position: absolute;
		margin-top: -3.25rem;
		position: absolute;
		margin-left: 1.5em;
		opacity: .4;
		transition: all 0.5s;
	}
	input:placeholder-shown + label{
		opacity: 0;
		font-size: 14px;
		margin-top: -2.5rem;
		margin-left: 1.125em;
		transition: all 0.5s;
		opacity: 0;
	}
	input{
		padding-top: 1rem;
		transition: all .5s;
	}
	input:placeholder-shown{
		padding-top: .5rem;
	}
	.form-control:focus{
		box-shadow: none !important;
		border: 2px solid var(--neutral-50, rgba(141, 141, 141, 0.93)) !important;
	}
</style>